export default __webpack_public_path__ + "static/media/template3.8c5ebaf4.png";